var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: "选择加入此考勤组",
            visible: _vm.drawer,
            size: "700px",
            wrapperClosable: false,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "box" },
            [
              _c("div", { staticClass: "tips mb20" }, [
                _vm._v("以下成员已加入其他考勤组，请选择是否加入考勤组"),
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.tableData, "tooltip-effect": "dark" },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "人员姓名", width: "120" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "position", label: "部门", width: "180" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return _vm._l(
                            scope.row.frames,
                            function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "frame-name over-text",
                                },
                                [
                                  _c("span", { staticClass: "icon-h" }, [
                                    _vm._v(
                                      "\n                " + _vm._s(item.name)
                                    ),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              item.is_mastart === 1 &&
                                              scope.row.frames.length > 1,
                                            expression:
                                              "item.is_mastart === 1 && scope.row.frames.length > 1",
                                          },
                                        ],
                                        attrs: { title: "主部门" },
                                      },
                                      [_vm._v("(主)")]
                                    ),
                                  ]),
                                ]
                              )
                            }
                          )
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "job.name",
                      label: "职位",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "group.name",
                      label: "所在考勤组",
                      "show-overflow-tooltip": "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "button from-foot-btn fix btn-shadow" },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleClose } },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }